import { type ReactNode } from 'react'

import { LegalPage } from './LegalPage'
import { DATA_PROTECTION } from '../content/legal'

/**
 * `/data-protection` — M17-T17.
 *
 * Its own route rather than a section of the privacy policy: AMTC approved it
 * as a separate document, and T17 accepts either shape. Text in `docs/legal/`.
 */
export function DataProtection(): ReactNode {
  return <LegalPage doc={DATA_PROTECTION} />
}
